import { render, staticRenderFns } from "./NewFeaturesControl.vue?vue&type=template&id=b8100aa6&scoped=true"
import script from "./NewFeaturesControl.vue?vue&type=script&lang=js"
export * from "./NewFeaturesControl.vue?vue&type=script&lang=js"
import style0 from "./NewFeaturesControl.vue?vue&type=style&index=0&id=b8100aa6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8100aa6",
  null
  
)

export default component.exports